/*
 * Translation file for locale
 * ---------------------------------
 * Struct:
 *    // Common labeling Block
 *    common: {
 *       lbl1: 'YYYYY'
 *    },
 *    // Pages Block --> Seguir nombres de pages
 *    pages: {
 *       about: {
 *          lbl1: 'ZZZZ'
 *       }
 *    },
 *    // Compnents block --> Seguir misma estructura que ficheros
 *    components: {
 *       home: {
 *          NavigationBarComponent : {
 *              lbl1: 'XXXX'
 *          }
 *       }
 *    }
 *
 * */

export const es = {
    defaultlocale: "es-es",
    common: {
        appname: "IRIS",
        btn_audit_trail: "Historial",
        btn_edit: "Editar",
        btn_delete: "Eliminar",
        btn_cancel: "Cancelar",
        btn_ok: "Ok",
        btn_save: "Guardar",
        btn_review: "Revisar",
        btn_remove_review: "Ocultar Revisión",
        btn_view_replies: "Ver respuestas",
        lbl_success: "Cambios Guardados correctamente",
        lbl_error: "Error al guardar cambios",
        lbl_edit: "Editar",
        lbl_delete: "Eliminar",
        lblClose: "Cerrar",
        lblSave: "Guardar",
        lblReset: "Limpiar",
        confirmdelete: "Estás seguro de que deseas borrar la selección actual?",
        with: "with",
        generatingfile: "Compressing files",
        errorgeneratingfile: "Error on Download",
        downloadingfile: "Downloading file",
        download: "Descargar",
        modalAudit: {
            lblTitle: "Control de Cambios",
            msgNoChanges: "¡No hay cambios!",
            lblUser: "Cambio realizado por:",
            table: {
                colField: "Campo",
                colBefore: "Valor Anterior",
                colAfter: "Valor Final"
            }
        },
        modalExcel: {
            message: "Link para descargar",
            link: "Descargar Excel",
            error: "Error creando excel",
            error413: "Se ha excedido el límite de descarga. Afine los filtros."
        },
        comments: {
            title: "Comentarios",
            btn_new: "Añadir",
            btn_reply: "Responder",
            txt_newcomment: "Nuevo comentario",
            txt_comment_deleted: "Comentario eliminado",
            btn_view_replies: "Ver respuestas",
            msg_comm_deleted_confirm: "¿Seguro que desea eliminar este mensaje?",
            msg_comm_added_success: "Comentario añadido",
            msg_comm_added_error: "El comentario no se ha podido añadir",
            msg_comm_edited_success: "Comentario editado",
            msg_comm_edited_error: "El comentario no se ha podido editar",
            msg_comm_deleted_success: "Comentario eliminado",
            msg_comm_deleted_error: "El comentario no se ha podido eliminar"
        },
        documents: {
            TITLE: "Documentos",
            colModel: {
                Name: "Nombre del documento",
                Description: "Descripción",
                Type: "Tipo",
                PicType: "Tipo de fotografía",
                Date: "Fecha",
                ExpDate: "Fecha de vencimiento",
                AddReport: "Inc. Informe",
                IsConfidential: "Confidencial",
                MinSecLevel: "Nivel min securidad",
                toSign: "Para firma"
            },
            ToolbarHints: {
                Edit: "Editar selección",
                Delete: "Borrar selección",
                Miniatures: "Ver miniaturas",
                Gallery: "Ver galería",
                Audit: "Historial",
                Folder: "Nueva carpeta",
                ListAll: "Incluir borrados",
                ListActive: "Ver solo los activos",
                Download: "Descargar selección",
                BackToDocs: "Volver a listado de documentos"
            },
            AddFolderModal: {
                Title: "Añadir carpeta",
                Message: "Por favor, introduzca el nombre de la carpeta",
                FolderName: "Nombre de la carpeta",
                msg_toasted_added: "Nueva carpeta añadida!",
                msg_toasted_no_added:
                    "Ha ocurrido un problema mientras se añadía la nueva capreta, por favor inténtelo de nuevo",
                msg_toasted_zipEmpty: "ZIP VACÍO!!!",
                msg_toasted_no_name: "Debe introducir un nombre para la nueva carpeta"
            },
            DownloadZipModal: {
                Title: "Descargar ZIP",
                Message: "Un único fichero ZIP se va a descargar con ",
                Confirm: " documentos. Este proceso puede tardar, ¿está seguro?",
                msg_toasted_zipOK: "ZIP creado!! Descargando...",
                msg_toasted_zipEmpty: "ZIP VACÍO!",
                msg_toasted_zipERROR:
                    "Ha ocurrido un error mientras se creaba el ZIP. Inténtelo otra vez"
            },
            EditModal: {
                msg_toasted_edited: "Documentos editados!!",
                msg_toasted_no_edited:
                    "Ha ocurrido un error al editar los documentos. Inténtelo otra vez!!",
                greaterThan100Mb: "El documento excede el límite de 100Mb impuesto por Adobe para la tramitación de documentos"
            },
            DeleteModal: {
                Message: "¿Está seguro de borrar los documentos seleccionados?",
                msg_toasted_deleted: "Documentos borrados!!",
                msg_toasted_no_deleted:
                    "Ha ocurrido un error al borrar los documentos. Inténtelo otra vez!!"
            },
            DropZone: {
                AddBtn: "Mostrar subida de documentos",
                RemoveBtn: "Ocultar subida de documentos",
                IsConfidentialBtn: "Marcar los documentos adjuntos como confidenciales",
                DropFileText: "arrastre un archivo...",
                DropFileBtn: "Seleccione un archivo",
                UploadBtn: "Subir todos archivos",
                UploadedMsg: "Subido",
                UploadedErrorMsg: "Error al subir",
                ReadyToUploadMsg: "Preparado para subir"
            },
            dueDiligence: {
                title: "Due Diligence"
            }
        }
    },
    pages: {
        about: {
            table: {
                colname: "Nombre",
                coltitle: "Alias"
            },
            name: "Información"
        },
        sample: {
            name: "Nombre",
            type: "Tipo",
            code: "Código",
            search: "Búsqueda",
            country: "País"
        }
    },
    components: {
        navigation_bar: {
            title_users: "Usuarios",
            title_roles: "Roles",
            title_profiles: "Perfiles",
            title_refresh_cache: "Refrescar caché",
            title_esign: "ESIGN",
            title_esign_JLL: "JLL",
            title_esign_TETRIS: "TÉTRIS",
            title_esign_dashboard: "DASHBOARD",
            title_esign_JLLT: "JLLT",
            title_esign_HR: "RRHH",
            title_esign_minus: "ESign",
            title_due_diligence: "Due Diligence",
            title_informa: "Informa",
            title_authmappings: "Auth Mappings",
            title_approvers: "Aprobadores ESign",
            title_healthchecks: "Healthchecks",
            esignmanuales: "ESign Manual",
            esignmanualpt: "Guia de Utilização do E- Sign Portugal",
            esignmanualresidentialpt: "Guia de Utilização do E- Sign Residential",
            esignmanualtetrispt: "Guia de Utilização do E-Sign Tétris"
        },
        dynamicfilters: {
            field: "Propiedad a filtrar",
            operation: "Operación",
            setvalue: "Valor",
            selectvalue: "Valores",
            notvalid: "Esté filtro no está completo"
        },
        pagination: {
            of: "de",
            rows: "filas"
        },
        genericTable: {
            columnList: {
                modalTitle: "Lista de columnas disponibles",
                index: "N",
                column: "Columna",
                isVisible: "Visible",
                msgConfigSaved: "Configuración guardada.",
                msgConfigSavedErr: "Error guardando la configuración."
            }
        },
        esignapproversmanagement: {
            addedsentence: "El usuario {email} se añadirá con nombre {name} como aprobador para el area {area} en la entidad legal {legalentity}",
            deletedsentence: "El usuario {email} con nombre {name} dejará de ser aprobador para el area {area} en la entidad legal {legalentity}",
            title: "Gestión de aprobadores (JLL)",
            tetrisaddedsentence: "El usuario {email} se añadirá con nombre {name} como aprobador",
            tetrisdeletedsentence: "El usuario {email} con nombre {name} dejará de ser aprobador",
            tetristitle: "Gestión de aprobadores (Tetris)",
            email: "Email",
            name: "Nombre",
            area: "Area",
            addapprover: "Añadir aprobador",
            commit: "Guardar Cambios",
            email_validation: "El correo electrónico es un campo obligatorio",
            area_validation: "Área es un campo obligatorio",
            name_validation: "El nombre es un campo obligatorio",
            addedstage: "Aprobadores para añadir",
            deletedstage: "Aprobadores para eliminar",
            filtervalidation: "No se permite guardar los cambios mientras los filtros estén activos",
            itemexists: "Este item ya existe"
        },
        role: {
            name_label: "Rol",
            overview_label: "Descripción",
            title: "Roles",
            edit_title: "Editar Rol",
            create_title: "Nuevo Rol",
            name_validation: "El nombre es obligatorio",
            overview_validation: "La descripción es obligatoria"
        },
        profile: {
            title: "Perfiles",
            associates_title: "Roles asociados al perfil",
            name_label: "Perfil",
            overview_label: "Descripción",
            edit_title: "Editar Perfil",
            create_title: "Nuevo Perfil",
            assign_role_title: "Asignar Rol",
            name_validation: "El nombre es obligatorio",
            overview_validation: "La descripción es obligatoria"
        },
        user: {
            title: "Usuarios",
            associates_title: "Perfiles asociados al usuario",
            name_label: "Usuario",
            email_label: "Email",
            from_label: "Copiar perfiles del usuario",
            to_label: "para el usuario",
            edit_title: "Editar Usuario",
            create_title: "Nuevo Usuario",
            assign_profile_title: "Asignar Perfil",
            copy_profiles_title: "Copiar Perfiles",
            name_validation: "El nombre es obligatorio",
            email_validation: "El email es obligatorio",
            not_same_user_validation: "Los usuarios seleccionados no deben coincidir"
        },
        dueDiligence: {
            title: "Due Diligence",
            status: "Estado",
            persontype: "Entidad jurídica/Persona física",
            country: "País",
            providertype: "Contraparte",
            clienttype: "Tipo de riesgo",
            RB: "Riesgo Bajo",
            RM: "Riesgo Medio",
            RA: "Riesgo Alto",
            EX: "Excluido",
            PF: "Persona física",
            CIF: "CIF",
            country_validation: "El país es obligatorio",
            CIF_validation: "El CIF es obligatorio",
            clientdescription: "Nombre del cliente",
            clientdescription_validation: "El nombre es obligatorio",
            providertypeparam: "Contraparte",
            providertypeparam_validation: "La contraparte es obligatoria",
            naturalpersonparam: "Tipo",
            naturalpersonparam_validation: "El tipo es obligatorio",
            pbcclientparam: "Tipo",
            pbcclientparam_validation: "El tipo es obligatorio",
            ispep: "Es una persona potencialmente expuesta",
            ispep_validation: "Este campo es obligatorio",
            persontype: "Entidad jurídica/Persona física",
            persontype_validation: "El tipo de persona es obligatorio",
            startdate: "Fecha de inicio",
            startdate_validation: "La fecha de inicio es obligatoria",
            enddate: "Fecha de cierre",
            enddate_validation: "El campo Fecha de cierre es obligatorio",
            email: "E-mail",
            addemail: "Escribe un email valido y pulsa la tecla enter",
            changestatus_title: "Cambio de estado",
            changestatus_validation: "Debes seleccionar un nuevo estado",
            changestatus_unchanged_validation:
                "No puedes seleccionar el estado actual",
            nextstatus: "Nuevo estado",
            create_title: "Nuevo Registro",
            edit_title: "Editar Registro",
            statustrack_title: "Historial de cambios de estado",
            mailcommentcreate: "El usuario <b>{user}</b> ha añadido un comentario respecto del expediente<b> {description} ({cif})</b>.",
            mailcommentedit: "El usuario <b>{user}</b> ha editado un comentario respecto del expediente<b> {description} ({cif})</b>.",
            mailcommentreply: "El usuario <b>{user}</b> ha respondido comentario respecto del expediente<b> {description} ({cif})</b>."
        },
        statustable: {
            status: "Estado",
            date: "Fecha",
            deltatime: "Tiempo Delta",
            username: "Usuario",
            WAITING_FOR_MY_SIGNATURE: "	Pendiente de firmar",
            WAITING_FOR_OTHERS: "Firma completada y esperando firma de otros",
            COMPLETED: "Completada",
            NOT_YET_VISIBLE: "No visible, esperando la firma de otros",
            Days: "días",
            Hours: "horas",
            Minutes: "minutos",
            Seconds: "segundos",
            None: " - ",
            sendreminder: "Enviar Recordatorio",
            reminderrecentlysent: "A reminder has already been sent today"
        },
        informa: {
            title: "Informa",
            cif: "CIF",
            cif_name: "Nombre",
            create_title: "Añadir CIF Informa",
            cif_validation: "El CIF es un valor obligatorio",
            cif_name_validation: "El Nombre es un valor obligatorio",
            edit_title: "Editar CIF Informa"
        },
        esigntetris: {
            estitle: "TÉTRIS ARQUITECTURA S.L.U.",
            ittitle: "Tetris Design & Build Srl",
            pttitle: "FITOUTETRIS S.A.",
            feesrange: "Rango de precio",
            feesvalidation:
                "El precio del contrato introducido no está dentro del rango seleccionado"
        },
        esigntetrisform: {
            partydetails: "DETALLES DE LA PARTE TÉTRIS",
            projectlocation: "Ubicación del proyecto",
            regionalclient: "Cliente regional",
            structuralwork:
                "Impacto/trabajo en estructura o fachada, impermeabilizacion, instalaciones o afectando a habitabilidad",
            structuralworkdetail: "Detalle",
            protectedbuilding: "Edificio protegido",
            protectedbuildingdetail: "Detail",
            licenseresponsability:
                "¿Es Tétris responsable de la obtención de la licencia?",
            licenseresponsabilitydetail: "Detalle",
            workguaranteeperiod: "Responsabilidad Contractual por defectos",
            workguaranteeperiodrange: "Rango",
            bankguarantee: "Garantía bancaria",
            bankguaranteerange: "Rango",
            retention: "Retenciones",
            retentionrange: "Rango",
            penalties: "Penalizaciones por retraso",
            penaltiesamount: "Cantidad",
            caponpenalties: "Limite en penalizaciones por retraso",
            caponpenaltiesrange: "Rango",
            riskanalisys: "ANÁLISIS DE RIESGOS DE NEGOCIO",
            includeriskanalisys: "¿Incluir análisis de riesgos de negocio?",
            anticorruptionclause: "Claúsula anticorrupción añadida en el contrato",
            pcg: "Parent Company Guarantee",
            pricemodality: "Modalidad de precio",
            pricemodalitydetail: "Detalle",
            prepaid: "Pago anticipado",
            prepaidguarantee: "Garantía del pago anticipado",
            prepaidamount: "Cantidad",
            template: "¿Es un template de TÉTRIS?",
            feesRange: "Rango de precio",
            fees: "Importe exacto del contrato",
            feesvendor: "Precio del contrato",
            feesrangevalidation:
                "El precio del contrato introducido no está dentro del rango seleccionado",
            durationofworks: "Duración",
            isocode: "Código ISO",
            tetrissoftcode: "Código Tetris Soft",
            clientrequestnumber: "Número request cliente IRIS",
            legalliabilityyearsmsg: "De 3 a 10 años de garantia legal ",
            portugaliabilitymessage: "5 años de garantía",
            signee1: "Email firmante TÉTRIS (1)",
            signee2: "Email firmante TÉTRIS (2)",
            projectnumber: "Nº de Proyecto"
        },
        esign: {
            estitle: "JONES LANG LASALLE ESPAÑA, S.A.",
            ittitle: "JONES LANG LASALLE",
            pttitle: "JLL",
            configmessage:
                "No tiene permisos suficientes para acceder a esta sección de IRIS o faltan algunos parámetros de configuración",
            confirmstatuschage:
                "Por favor, asegúrese de haber adjuntado los documentos para aprobar y firmar, y de haber completado la solicitud. Si acepta, no podrá hacer modificaciones.",
            confirmstatuschageinternalsignature:
                "Ha marcado este request para “aprobación interna” y no se admiten modificaciones durante la fase de aprobación. Una vez totalmente aprobado DEBERÁ subir en este mismo request el documento firmado externamente.",
            confirmcoveralert:
                "Recuerde que todos los documentos a ser firmados deben llevar el check de firma - a modificar en la ventana de documentos -",
            confirmsignature:
                "¿Seguro de que desea enviar los documentos adjuntos para firma?",
            confirminternalsignature: "Ha marcado este request para “aprobación interna”, NO debe pulsar “enviar a firma” hasta que no haya subido el documento firmado externamente por ambas partes, ya que se cerrará el request sin posibilidad de modificación.",
            approval_title: "Aprobación",
            esignstatuswf: "Estado",
            counterparty: "Contraparte",
            persontype: "Entidad jurídica/Persona física",
            legalentity: "Entidad Legal",
            area: "Area",
            segment: "Segmento",
            contracttype: "Tipo de contrato",
            feesrange: "Rango de honorarios",
            approver: "Aprobador",
            mindate: "Fecha creación Min",
            maxdate: "Fecha creación Max",
            cancelconfirm: "¿Está seguro de cancelar esta selección?",
            justifycomment:
                "Por favor, introduzca algunos comentarios para justificar su decisión:",
            approvaltext:
                "Después de revisar el formulario relleno por el solicitante, ¿desea aprobar o denegar?",
            add_approver_title: "Añadir Aprobadores",
            cancel_title: "Cancelar Transacción",
            approval_title: "Aprobar o denegar transacción",
            statustrack_title: "Historial de cambios de estado",
            agreements_title: "Firmantes",
            addapprovertext:
                "Por favor, teclea una dirección de email y presiona enter para agregar un aprobador extra para esta solicitud: ",
            addapproveralert:
                "Espere a que el aprobador extra apruebe o deniegue para seguir con el proceso de aprobación",
            create_transaction: "Nueva solicitud de aprobación y firma",
            review_transaction: "Revisar solicitud de aprobación y firma",
            edit_transaction: "Editar solicitud de aprobación y firma",
            nochangedvalidation: "El estado no ha cambiado",
            feesvalidation:
                "Los honorarios introducidos no están dentro del rango seleccionado",
            inputsvalidation:
                "Los campos obligatorios deben completarse y adjuntarse los documentos antes de guardar",
            mailcommentcreate: "El usuario <b>{user}</b> ha añadido un comentario sobre el formulario <b>{description}</b> creado por {solicitant}.",
            mailcommentedit: "El usuario <b>{user}</b> ha editado un comentario sobre el formulario <b>{description}</b> creado por {solicitant}.",
            mailcommentreply: "El usuario <b>{user}</b> ha respondido a tu comentario sobre el formulario <b>{description}</b> creado por {solicitant}.",
            approvaltooltip: "Aprobar o denegar",
            sendtosigntooltip: "Enviar para firma",
            projectnumber: "Nº de Proyecto",
            invalid_employee_mail_validation: "El email del empleado no es válido",
            required_signatory_one_validation: "El firmante 1 es obligatorio",
            invalid_scheduled_date_validation: "La fecha de lanzamiento de firma no puede ser anterior a la fecha actual",
            missing_required_fields_validation: "Faltan campos obligatorios",
            invalid_users_info_validation: "La información de los destinatarios no es válida",
        },
        dashboards: {
            tetrisTitle: "Número de contratos por categoría"
        },
        esignform: {
            partydetails: "DETALLES DE LA PARTE JLL",
            counterpartydetails: "DETALLES DE LA CONTRAPARTE",
            contractdetails: "DETALLES DEL CONTRATO",
            signees: "FIRMANTES",
            description: "Identificador solicitud",
            solicitantName: "Nombre del solicitante",
            solicitantMail: "Email del solicitante",
            behalf: "Solicitado en nombre de...",
            legalEntity: "Entidad legal",
            area: "Área",
            segment: "Segmento",
            subsegment: "Subsegmento",
            approver: "Aprobador/Line Manager",
            oportunityNum: "CRP o Num. Oportunidad",
            feesrangevalidation:
                "Los honorarios introducidos no están dentro del rango seleccionado",
            liability: "Límite de responsabilidad",
            counterparty: "Contraparte",
            personType: "Entidad jurídica/Persona física",
            contractType: "Tipo de contrato",
            startDate: "Fecha contrato",
            endDate: "Fecha fin contrato",
            template: "¿Es un template de JLL?",
            reviewed: "Revisado por abogado",
            object: "Objeto",
            activeName: "Nombre del activo / Dirección completa",
            feesRange: "Rango de honorarios",
            fees: "Honorarios",
            id: "DNI",
            namesurname: "Apellidos, Nombre",
            vat: "CIF",
            companyname: "Denominación social",

            executed: "Contrato ejecutado y firmado",
            onlyInternalApproval: "Contrato solo para aprobación interna",
            counter: "Contrato ya firmado por la contraparte",
            counterPartySignees: "Emails firmantes de la contraparte",
            signee1: "Email firmante JLL (1)",
            signee2: "Email firmante JLL (2)",
            addMeasures: "Otro..",
            endOfWOrks: "Fecha fin de trabajos",
            endDateNP: "Notificación fin de contrato",
            projectname: "Nombre de proyecto",
            leasingpercentage: "% del precio de compra/arrendamiento"
        },

        stepper: {
            initial_status: "Estado Inicial",
            cover_completed: "Ficha Completa",
            approval_completed: "Aprobación Completa",
            sent_to_sign: "Enviado para firma",
            signature_completed: "Firma Completa",
            linemanager: "Approval - Line Manager",
            datacontroller: "Approval - Data Controller",
            dccorporate: "Approval - DC Corporate",
            hr: "Approval - HHRR",
            ceo: "Approval - CEO",
            cfo: "Approval - CFO",
            legalandcompliance: "Approval - Legal & Compliance",
            hs: "Approval - Health Safety",
            finance: "Approval - Finance",
            compliance: "Approval - Compliance",
            legal: "Approval - Legal",
            datacontroller: "Approval - Data Controller",
            resiblegal: "Approval - Resi. B. Legal",
            leaderbline: "Approval - Leader B. Line",
            hse: "Approval - HSE",
            controller: "Approval - Controller",
            documentcontroller: "Approval - Document Controller"
        },
        approval: {
            comment_validation: "Debes añadir un comentario"
        },
        counterparty: {
            client: "Cliente",
            vendor: "Proveedor / Colaborador"
        },
        ddd: {
            client: {
                title: "DECLARACIÓN CDD*",
                titleportugal: "DECLARACIÓN CDD*",
                body:
                    "Declaro que he llevado a cabo las siguientes comprobaciones referidas al cliente y las he archivado según se indica en Políticas Globales/ Regionales, así como en Procedimientos Locales",
                li1: "Solvencia",
                li2: "Conflicto de interés",
                li3: "Reputación",
                li4: "Documentación firmante/s",
                li5: "Prevención Blanqueo Capitales/sanciones (si fuera de aplicación)",
                li6: "Otras medidas: (incluya texto)",
                check1:
                    "Declaro que la empresa tiene capacidad suficiente para dar servicio a este cliente.",
                check2:
                    "Declaro que, como resultado de la DD llevada a cabo, el cliente es apto y no presenta riesgos.",
                check3:
                    "Declaro que he tenido en cuenta, solicitado y obtenido todas las aprobaciones necesarias (en su caso), conforme a las politicas internas vigentes de JLL y/o Tétris.",
                    itcheck1: "Declaro que la empresa tiene la capacidad de firmar el documento y cumplir con las obligaciones incluidas en el mismo para con el Cliente",
                    itcheck2: "Declaro que el Cliente es una persona idónea y no presenta riesgos."
            },
            vendor: {
                title: "DECLARACIÓN VDD*",
                titleportugal: "DECLARACIÓN VDD*",
                body:
                    "Declaro que he llevado a cabo las siguientes comprobaciones referidas al proveedor y las he archivado según se indica en Políticas Globales/ Regionales, así como en Procedimientos Locales",
                li1: "Reputación",
                li2: "Solvencia",
                li3: "Capacidad técnica/profesional",
                li4: "Adherencia al Código de Conducta (política 36)",
                li5: "Cobertura de seguro",
                li6: "Pagos a la Seguridad Social",
                li7: "Pagos al Tesoro",
                li8: "Otras medidas: (incluya texto)",
                check1:
                    "Declaro que, como resultado de la DD llevada a cabo, el proveedor es apto y no presenta riesgos.",
                check2:
                    "Declaro que he tenido en cuenta, solicitado y obtenido todas las aprobaciones necesarias (en su caso), conforme a las politicas internas vigentes de JLL y/o Tétris.",
                itcheck1: "Declaro que la empresa tiene la capacidad para firmar el documento y cumplir con las obligaciones contenidas en el mismo para con el Proveedor / Colaborador",
                itcheck2: "Declaro que el Proveedor/Colaborador es una persona idónea y no presenta riesgos.",
                itcheck3: "He tenido en cuenta, solicitado y obtenido todas las aprobaciones necesarias (en su caso), de acuerdo con las políticas internas vigentes de JLL y/o Tetris"
            }
        },
        authorizationmappings: {
            controllertitle: "Mapeos de controlador",
            actiontitle: "Mapeos de acción",
            action: "Acción",
            controller: "Controlador",
            indb: "En BD",
            attribute: "Atributo añadido",
            assembly: "Existe",
            role: "Rol",
            roles: "Roles",
            controllerform: "Mapeos de controlador",
            actionform: "Mapeos de acción",
            rolelist_validation: "Selecciona un rol por lo menos",
            controller_validation: "Selecciona un controlador",
            action_validation: "Selecciona una acción",
            
        },
        contracttype: {
            nda: "NDA",
            ndainside: "NDA Inside Information",
            advisory: "(Just) Advisory or Consultancy",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdspjmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            consultancy: "Consultancy",
            subcontractingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            collaborationsp: "Collaboration (Service Provider)",
            otherservices: "Other Services (please indicate)",
            internalpurchases: "Internal Purchases (no revenue related)",
            design: "Diseño (solo)",
            otherservicesnoconstruction: "Otros servicios (no obra)",
            otherservicesrelatedbuild: "Other services related to Build",
            construction: "Obra (solo)",
            designandconstruction: "Diseño y Obra",
            furnituresupply: "Suministro de Mobiliario",
            extensionofworkorservice: "Ampliación de Obra o Servicio",
            masterserviceagreement: "Master Service Agreement",
            certificateofmeetings: "Acta reuniones/obra",
            furniturelogisticsoperator: "Operador Logístico de Mobiliario",
            discount: "Descuento por Volumen / Rappel / Prescripción",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Instalación de Materiales (solo)",
            instalationandmaterials: "Instalación y Materiales",
            corporatepurchases: "Compras Corporativas (Soporte)",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Recibo IT",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        },
        contracttypegrp: {
            nda: "NDA",
            advisoryorconsultancy: "Advisory or Consultancy",
            subcontratingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            otherservicesnoconstruction: "Otros servicios (no obra)", //TOADD
            otherservicesrelatedbuild: "Other services related to Build",
            otherservices: "Other Services",
            internalpurchases: "Internal Purchases",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdsprojectmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            design: "Diseño (solo)",
            construction: "Obra",
            designandconstruction: "Diseño y Obra",
            furnituresupply: "Suministro de Mobiliario",
            furniturelogisticsoperator: "Operador Logístico de Mobiliario",
            extensionofworkservice: "Ampliación de Obra o Servicio",
            discount: "Descuento por Volumen / Rappel / Prescripción",
            masterserviceagreement: "Master Service Agreement",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Instalación de Materiales (solo)",
            instalationandmaterials: "Instalación y materiales",
            corporatepurchases: "Compras Corporativas (Soporte)",
            certificateofmeetings: "Acta reuniones/obra",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Recibo IT",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        }
    },
    app: {
        lbl_title: "Seguridad",
        lbl_text: "Activando seguridad, por favor espere...",
        lbl_back_login: "Acceso a la aplicación...",
        lbl_load_roles: "Roles de usuario...",
        lbl_load_instance: "Cargando instancia...",
        lbl_error_login:
            "Error en el login, si persiste limpie la cache del navegador."
    },
    esign_hr: {
        title: "Módulo ESign para RRHH",
        loading: "Cargando...",
        filter: {
            society: "Sociedad",
            status: "Estado",
            contracttype: "Tipo de contrato",
            mindate: "Fecha Min.",
            maxdate: "Fecha Max."
        },
        send_test_form: {
            email: "Email",
            title: "Enviar email de prueba",
            send_test_desc: "Antes de iniciar el proceso de firma con Adobe Sign, es posible simular la experiencia de cada participante utilizando una única dirección de correo electrónico. Todos los mensajes relacionados con el proceso se enviarán a esta dirección, permitiéndote verificar la correcta configuración del documento y asegurar que el flujo de firmas se ajusta a tus necesidades. Esta práctica te ayudará a optimizar el proceso antes de implementarlo con los destinatarios reales.",
            status_error: "El estado debe ser Cover completa o Estado Inicial",
            required_email: "El Email es un campo obligatorio",
            invalid_email: "El email no es válido",
            server_error: "Error del servidor: Por favor, verifique si existen documentos marcados para firmar."
        },
        form: {
            reqNumber: "Número de request",
            employee: {
                name: "Nombre del empleado",
                email: "Email del empleado"
            },
            society: "Sociedad",
            contractType: "Tipo de contrato",
            bDate: "¿Envío inmediato?",
            isCampaign: "Es una campaña",
            recipients: "Destinatarios",
            launchDate: "Fecha de lanzamiento del contrato",
            bJLLsignee: "¿Hay firmante por parte de JLL?",
            jllsigneeEmail1: "Firmante JLL (1)",
            jllsigneeEmail2: "Firmante JLL (2)",
            freeTextTitle: "Texto en email",
            freeText: "Text libre para añadir al cuerpo del mensaje solicitando la firma",
            comments: "Observaciones",
            create: "Nuevo registro",
            edit: "Editar registro",
            review: "Revisar registro",
            dropdownoptions: {
                society: {
                    jll: "Jones Lang LaSalle España",
                    tetris: "Tétris Arquitectura",
                    ifm: "JLL Facility Services (IFM)"
                },
                contracttype: {
                    work: "Contrato de trabajo",
                    signature: "Firmas",
                    append: "Anexos",
                    other: "Otros"
                }
            }
        }
    }
};
